import printJS from "print-js";
import React, { useRef } from "react";
import Swal from "sweetalert2";

const PrintBookingDetails = ({ booking, onSuccess }) => {
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      Swal.fire("Error", "Print reference not found", "error");
      return;
    }

    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this booking detail?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          printJS({
            printable: printContent.innerHTML,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              Swal.fire({
                title: "Printing",
                text: "Booking detail is being processed...",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
              });

              if (onSuccess) {
                onSuccess();
              }
            },
          });
        } catch (error) {
          console.error("PrintJS Error:", error);
          Swal.fire("Error", "Failed to print booking detail", "error");
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Print operation cancelled.",
          icon: "info",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  return (
    <div>
      {/* 🔹 Print Button */}
      <button className="btn btn-sm btn-success" onClick={handlePrint}>
        Print
      </button>

      <div ref={printRef} style={{ display: "none" }}>
        <style>
          {`
          @media print {
            body {
              font-family: Arial, sans-serif;
              width: 58mm;
              padding: 5px;
            }
            .receipt {
              text-align: center;
              width: 100%;
              font-size: 12px;
            }
            .border-dashed {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
            table {
              width: 100%;
              font-size: 12px;
              border-collapse: collapse;
            }
            td, th {
              padding: 4px 0;
              text-align: left;
            }
            .right {
              text-align: right;
            }
            .center {
              text-align: center;
            }
          }
          `}
        </style>
        {/* Logo */}
        <div className="receipt">
          <img src="/Kuber.jpeg" alt="Logo" style={{ width: "50px" }} />
          <p><strong>KUBER BALI ADVENTURE</strong></p>
          <p>Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
          <div className="border-dashed"></div>
        </div>
        {/* Detail Booking */}
        <table>
          <tbody>
            <tr>
              <td><strong>Code</strong></td>
              <td className="right">{booking.code}</td>
            </tr>
            <tr>
              <td><strong>Date</strong></td>
              <td className="right">{booking.reservation_date}</td>
            </tr>
            <tr>
              <td><strong>Guest</strong></td>
              <td className="right">{booking.guest_name}</td>
            </tr>
            <tr>
              <td><strong>Agent</strong></td>
              <td className="right">{booking.agent?.name || "N/A"}</td>
            </tr>
          </tbody>
        </table>
        <div className="border-dashed"></div>
        {/* Detail Produk */}
        <table>
          <thead>
            <tr>
              <th>Activity</th>
              <th className="right">Qty</th>
            </tr>
          </thead>
          <tbody>
            {booking.activities.map((activity, index) => (
              <tr key={index}>
                <td>{activity.activity}</td>
                <td className="right">{activity.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Detail Pembayaran */}
        <div className="border-dashed"></div>
        <table>
          <tbody>
            <tr>
              <td><strong>Total Guest</strong></td>
              <td className="right">{booking.guest_pax}</td>
            </tr>
            <tr>
              <td><strong>Total Paid</strong></td>
              <td className="right">Rp. {parseInt(booking.total_price).toLocaleString("id-ID")}</td>
            </tr>
          </tbody>
        </table>

        <div className="border-dashed"></div>
        <p className="receipt">
          <strong>Thank you for using our service!</strong>
        </p>
      </div>
    </div>
  );
};

export default PrintBookingDetails;
